import { createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "@app/components/ErrorBoundary";

import Login from "@pages/Login";
import GuestLayout from "@layouts/GuestLayout";
import AuthLayout from "@layouts/AuthLayout";
import { PRIVATE_PAGES, PUBLIC_PAGES } from "./pages";
import NotFoundPage from "@pages/NotFoundPage";
import CreateProduct from "@pages/CreateProduct";
import Products from "@pages/Products";
import EditProduct from "@pages/EditProduct";
import Messages from "@pages/Messages";
import Categories from "@pages/Categories";
import EditCategory from "@pages/EditCategory";
import CreateCategory from "@pages/CreateCategory";
import Certificates from "@pages/Certificates";
import MutationCertificates from "@pages/MutationCertificates";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <AuthLayout />
      </ErrorBoundary>
    ),
    children: [
      // ### ### ### ### ### ### ### ### ### ###
      {
        path: PRIVATE_PAGES.CATEGORIES,
        element: <Categories />,
      },
      {
        path: PRIVATE_PAGES.CREATE_CATEGORY,
        element: <CreateCategory />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_CATEGORY,
        element: <EditCategory />,
      },
      // ### ### ### ### ### ### ### ### ### ###
      {
        path: PRIVATE_PAGES.CERTIFICATES,
        element: <Certificates />,
      },
      {
        path: PRIVATE_PAGES.CREATE_CERTIFICATE,
        element: <MutationCertificates />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_CERTIFICATE,
        element: <MutationCertificates />,
      },
      // ### ### ### ### ### ### ### ### ### ###
      {
        path: PRIVATE_PAGES.MESSAGES,
        element: <Messages />,
      },
      {
        path: PRIVATE_PAGES.PRODUCTS,
        element: <Products />,
      },
      {
        path: PRIVATE_PAGES.CREATE_PRODUCTS,
        element: <CreateProduct />,
      },
      {
        path: PRIVATE_PAGES.UPDATE_PRODUCT,
        element: <EditProduct />,
      },
    ],
  },
  {
    path: "",
    element: <GuestLayout />,
    children: [
      {
        path: PUBLIC_PAGES.LOGIN,
        element: <Login />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default router;
